// material-ui
// import { useTheme } from '@mui/material/styles';

/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

// const Logo = () => {
//     const theme = useTheme();

//     return (
//         *
//          * if you want to use image instead of svg uncomment following, and comment out <svg> element.
//          *
//          * <img src={logo} alt="Berry" width="100" />
//          *
//         <img alt="" src="https://kalimera.vip/templates/yootheme/cache/logo-1df06b00.png" />
//     );
// };
const Logo = () => <img src="https://kalimera.vip/templates/yootheme/cache/logo-1df06b00.png" alt="Kalimera" width="150" />;

export default Logo;
